import { cx } from '@emotion/css';
import React from 'react';
import { Typography } from '../../electrons';
import { useStyles } from './VerticalJoiner.styles';
export function VerticalJoiner({ children, className, id, leftOffset }) {
    const classes = useStyles({ leftOffset });
    return (React.createElement("div", { className: cx(className, classes.root), id: id },
        React.createElement("div", { className: classes.container },
            React.createElement(Typography, { className: classes.textBox, variant: "h5" }, children))));
}
//# sourceMappingURL=VerticalJoiner.js.map